import { faCircleInfo } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
    Widget,
    WidgetContent,
    WidgetHeader,
    WidgetTitle,
} from "frontend-components";
import IssuesCategoryStats from "./IssuesCategoryStats";
import { IssuesTable } from "./IssuesTable";
import { useTranslation } from "react-i18next";

export function IssuesCategoryWidget() {
    const { t } = useTranslation();

    return (
        <Widget>
            <WidgetHeader>
                <WidgetTitle>{t("common.issuesByCategory")}</WidgetTitle>
                <TooltipProvider>
                    <Tooltip>
                        <TooltipTrigger
                            type="button"
                            aria-label={t("common.lastTwelveMonthsDisclaimer")}
                            className="text-compendia-muted hover:text-compendia-foreground focus-visible:ring-border-focus inline-flex size-4 items-center justify-center rounded-full focus-visible:ring-2 focus-visible:outline-none"
                        >
                            <FontAwesomeIcon icon={faCircleInfo} className="size-4" />
                        </TooltipTrigger>
                        <TooltipContent>{t("common.lastTwelveMonthsDisclaimer")}</TooltipContent>
                    </Tooltip>
                </TooltipProvider>
            </WidgetHeader>
            <WidgetContent>
                <IssuesTable />
                <IssuesCategoryStats />
            </WidgetContent>
        </Widget>
    );
}
